import { memo } from 'react';
import { handleDomBubbleEvent } from '@/utils/dom';
import {
  Modal,
  ModalHeader,
  ModalTitle,
  ModalContent,
  ModalFooter,
  ModalCloseButton,
  ModalConfirmButton,
} from '@/components/_ui/modal';
import { Spinner } from '@/components/_ui/spinner';
import { useArchiveTicketModal } from './use-archive-ticket-modal';

export type TArchiveTicketModalType = 'ArchiveTicketModal';
export interface IArchiveTicketModalProps {
  spaceId: string;
  ticketId: string;
  onStart?: () => Promise<void> | void;
  onSuccess?: () => Promise<void> | void;
}

const ArchiveTicketModal = memo(({ spaceId, ticketId, onStart, onSuccess }: IArchiveTicketModalProps) => {
  const {
    // FORM
    form,
    isOpen,
    isDisabledForm,
    isLoadingForm,

    // HANDLERS
    handleCancelModal,
    handleCloseModal,
    handleSubmitForm,
  } = useArchiveTicketModal({
    spaceId,
    ticketId,
    onSuccess,
    onStart,
  });

  // RENDER
  return (
    <Modal
      isOpen={isOpen}
      lockBodyScroll
      onClose={handleCloseModal}
      isCloseOutside={false}
      className="md:w-[500px] w-[345px] p-[24px]"
    >
      <ModalHeader>
        <ModalTitle>Are you sure you want to archive this ticket?</ModalTitle>
      </ModalHeader>
      <ModalContent>
        <form
          onSubmit={(e) => {
            handleDomBubbleEvent(e);
            form.handleSubmit(handleSubmitForm)(e);
          }}
          id="archive-ticketing-ticket-form"
          className="grid gap-[16px] mt-[16px]"
        >
          <span className="text-[14px] font-normal text-[#9D9D9C]">
            This ticket will be moved to the archive and removed from your active list. You can restore it anytime.
          </span>
        </form>
      </ModalContent>
      <ModalFooter>
        <ModalCloseButton
          onClick={(e) => {
            handleDomBubbleEvent(e);
            handleCancelModal();
          }}
        >
          Cancel
        </ModalCloseButton>
        <ModalConfirmButton form="archive-ticketing-ticket-form" type="submit" disabled={isDisabledForm}>
          {isLoadingForm ? <Spinner className="w-[18px] h-[18px]" /> : null} Archive
        </ModalConfirmButton>
      </ModalFooter>
    </Modal>
  );
});
ArchiveTicketModal.displayName = 'ArchiveTicketModal';
export default ArchiveTicketModal;
